import { type ColDef, type SpanRowsParams, themeQuartz } from "ag-grid-community"

import { type PricingGridRow } from "../types"

import { CURRENCY_RENDER_PRECISION } from "@/constants/formats"
import { AS400_PRICE_MAX } from "@/screens/Pricing/constants"

export const NON_EDITABLE_CELL_CLASS = "bg-gray-300 text-gray-700"

const DEFAULT_COLUMN_PROPS: ColDef<PricingGridRow> = {
  width: 130,
  sortable: false,
  resizable: false,
  headerClass: NON_EDITABLE_CELL_CLASS,
}

const NUMERIC_PROPS: ColDef<PricingGridRow> = {
  cellEditor: "agNumberCellEditor",
  type: "rightAligned",
  // rightAligned aligns via cellClass; a colDef cellClass (background) replaces it, so align via cellStyle instead
  cellStyle: { textAlign: "right" },
  cellEditorParams: {
    min: 0,
    precision: CURRENCY_RENDER_PRECISION,
  },
}

const PRICE_PROPS: ColDef<PricingGridRow> = {
  cellEditorParams: {
    min: 0,
    max: AS400_PRICE_MAX,
    precision: CURRENCY_RENDER_PRECISION,
  },
}

const DATE_PROPS: ColDef<PricingGridRow> = {
  cellEditor: "agDateStringCellEditor",
  cellDataType: "dateString",
  width: 150,
  cellEditorParams: {},
}

const SPANNED_PROPS: ColDef<PricingGridRow> = {
  spanRows: ({ valueA, valueB, nodeA, nodeB }: SpanRowsParams<PricingGridRow>) =>
    valueA === valueB && nodeA?.data?.item === nodeB?.data?.item,
}

const FLEX_PROPS: ColDef<PricingGridRow> = {
  flex: 1,
  width: undefined,
  minWidth: 130,
}

export const COLUMN_PROPS: Record<string, ColDef<PricingGridRow>> = {
  DEFAULT: DEFAULT_COLUMN_PROPS,
  DATE: DATE_PROPS,
  NUMERIC: NUMERIC_PROPS,
  PRICE: PRICE_PROPS,
  SPANNED: SPANNED_PROPS,
  FLEX: FLEX_PROPS,
}

export const MARGIN_THRESHOLDS = { LOW: 10, MEDIUM: 20 } as const

export const PRICING_GRID_THEME = themeQuartz.withParams({
  borderRadius: 0,
  wrapperBorderRadius: 0,
  columnBorder: { color: "#CFD8DC" },
  headerColumnBorder: { color: "#CFD8DC" },
})

export const LIST_PRICE_LABEL = "List Price"
